__webpack_require__.p = "/interactive/LenovoIntel/ai-innovators/";